import { FC } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box } from '@mantine/core'
import innertext from 'innertext'
import { useIntl } from 'react-intl'

import { formatArticle } from 'api/dataTransform'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { ArticleApi } from 'interfaces/types'
import { getAuthorFromArticleApi } from 'utils/author'

import { StyledHomeTrendingArticle } from './HomeTrendingLastestTopics.styled'
import { trendingCategory } from './index.constants'
import { CardArticle } from '../CardArticleV2'
import { CardArticleAuthorName } from '../CardArticleV2/CardArticleAuthor'

type TrendingArticleCardProps = {
  article: ArticleApi
  index: number
  activeTab: string
  currentDomain: string
  loading: boolean
  loadingBookmark: Record<string | number, boolean>
  bookmarks: (string | number)[]
  onClickBookmark: (id: number) => () => void
  type?: 'vertical' | 'horizontal'
  className?: string
  showExcerpt?: boolean
}

export const TrendingArticleCard: FC<TrendingArticleCardProps> = ({
  article,
  index,
  activeTab,
  currentDomain,
  loading,
  loadingBookmark,
  bookmarks,
  onClickBookmark,
  type = 'vertical',
  className,
  showExcerpt,
}) => {
  const { formatMessage: f } = useIntl()
  const { locale } = useRouterExtend()
  const formatted = formatArticle(article)
  const author = getAuthorFromArticleApi({
    article,
    locale,
    version: 'short',
  })

  return (
    <StyledHomeTrendingArticle className={className}>
      <CardArticle
        loading={loading}
        type={type === 'horizontal' ? 'horizontal' : undefined}
        showExcerpt={showExcerpt}
        item={{
          ID: parseInt(`${formatted.id}`),
          image1x1: formatted.featureImageWithRatio1x1,
          image: formatted.featureImage,
          permalink: formatted.permalink,
          title: innertext(formatted.postTitle || formatted.postName || ''),
          category: formatted.category,
          excerpt: formatted.excerpt,
          author: {
            avatar: author.avatar,
            avatarAlt: author.avatar_alt,
            permalink: author.avatar_permalink,
            name: (
              <>
                <CardArticleAuthorName
                  {...author}
                  formatOptionsProps={{
                    expert_display_name: {
                      'data-event-category': `Top Article Banner - ${trendingCategory?.[activeTab]}`,
                      'data-event-action': `Click ${index} - Doctor`,
                      'data-event-label': `${currentDomain}${basePath}${author.avatar_permalink}`,
                    },
                  }}
                />
                <Box
                  component="span"
                  sx={{ display: 'inline-block', margin: '0 4px' }}
                >
                  •
                </Box>{' '}
                <Text size="c1" as="span">
                  {f({
                    id: 'articleCard.updateDate',
                    defaultMessage: 'Ngày cập nhật',
                  })}
                  : {formatted.modifiedTime}
                </Text>
              </>
            ),
            indicator: author.indicator,
          },
        }}
        itemTracking={{
          image: {
            'data-event-category': `Top Article Banner - ${trendingCategory?.[activeTab]}`,
            'data-event-action': `Click ${index} - Article`,
            'data-event-label': `${currentDomain}${basePath}${formatted.permalinkDecode}`,
          },
          title: {
            'data-event-category': `Top Article Banner - ${trendingCategory?.[activeTab]}`,
            'data-event-action': `Click ${index} - Article`,
            'data-event-label': `${currentDomain}${basePath}${formatted.permalinkDecode}`,
          },
          category: {
            'data-event-category': `Top Article Banner - ${trendingCategory?.[activeTab]}`,
            'data-event-action': `Click ${index} - Category`,
            'data-event-label': `${currentDomain}${basePath}${formatted.category.permalinkDecode}`,
          },
          authorAvatar: {
            'data-event-category': `Top Article Banner - ${trendingCategory?.[activeTab]}`,
            'data-event-action': `Click ${index} - Doctor`,
            'data-event-label': `${currentDomain}${basePath}${author.avatar_permalink}`,
          },
        }}
        bookmarkButtonProps={{
          loading: !!loadingBookmark[formatted.id],
        }}
        isBookmark={!!bookmarks.includes(formatted.id)}
        onClickBookmark={onClickBookmark(parseInt(`${formatted.id}`))}
      />
    </StyledHomeTrendingArticle>
  )
}
